import React from 'react';

import styled from 'styled-components';

import CarStatusAvailable from '../../atoms/icons/CarStatusAvailable';
import CarStatusBusy from '../../atoms/icons/CarStatusBusy';

interface IInTransactionIcon {
  inTransaction: boolean;
}

export const InTransactionIcon = ({ inTransaction }: IInTransactionIcon) => {
  return <Div inTransaction={inTransaction}>{inTransaction ? <CarStatusAvailable /> : <CarStatusBusy />}</Div>;
};

const Div = styled.div<IInTransactionIcon>`
  position: relative;
  padding-left: 300%;
`;
